// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l1d1","left":"styles_left__39Z_F"};